import React, { useState } from "react";

// Mock data for Offer List
const offerData = [
  {
    srNo: 1,
    offerName: "Scheduled App Maintenance",
    offerDetail:
      "Dear Valued Customer, Namaste, Due to a scheduled maintenance activity all services will not be available on 20 September 2022 from 00:00 to 24 September 2022 02:00 AM. We appreciate your patience and understanding. As always, if you have questions or issues, please feel free to contact the Support Team. Thanks & Regards -Team ODHPAY.",
    status: "Blocked",
  },
  {
    srNo: 2,
    offerName: "CASH BACK",
    offerDetail:
      "प्रिय ओडीएचपे यूजर, अब प्रतिमाह अपने ओडीएचपे वॉलेट में न्यूनतम 2000 रु या उससे अधिक की औसत मासिक राशि बनाए रखने पर 1% प्रतिमाह का कैश बैक प्राप्त करें |",
    status: "Unblocked",
  },
  {
    srNo: 3,
    offerName: "Scheduled App Maintenance",
    offerDetail:
      "प्रिय वैल्यूड कस्टमर, नमस्ते, एक निर्धारित रखरखाव गतिविधि के कारण 20 सितंबर 2022 रात्रि 12 बजे से 24 सितंबर 2022 को पूर्वाह्न 02:00 बजे तक सभी सेवाएं उपलब्ध नहीं होंगी। हम आपके धैर्य और समझ की सराहना करते हैं। हमेशा की तरह, यदि आपको कोई प्रश्न या समस्याएँ हैं, तो कृपया बेझिझक सहायता के लिए टीम से संपर्क करें। धन्यवाद !! रेगार्ड्स - टीम ओडीएचपे",
    status: "Unblocked",
  },
];

const AddOffer = () => {
  const [offerName, setOfferName] = useState("");
  const [offerDetail, setOfferDetail] = useState("");
  const [offerList, setOfferList] = useState(offerData);
  const [offerStatus, setOfferStatus] = useState("Blocked");

  const handleCreateOffer = (e) => {
    e.preventDefault();
    if (offerName && offerDetail) {
      const newOffer = {
        srNo: offerList.length + 1,
        offerName: offerName,
        offerDetail: offerDetail,
        status: offerStatus,
      };
      setOfferList([...offerList, newOffer]);
      setOfferName("");
      setOfferDetail("");
    }
  };

  const handleStatusToggle = (srNo) => {
    const updatedList = offerList.map((offer) =>
      offer.srNo === srNo
        ? { ...offer, status: offer.status === "Blocked" ? "Unblocked" : "Blocked" }
        : offer
    );
    setOfferList(updatedList);
  };

  const handleEditOffer = (srNo) => {
    const offerToEdit = offerList.find((offer) => offer.srNo === srNo);
    setOfferName(offerToEdit.offerName);
    setOfferDetail(offerToEdit.offerDetail);
    setOfferStatus(offerToEdit.status);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Add Offer</h2>
      <form onSubmit={handleCreateOffer} style={styles.form}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Offer Name</label>
          <input
            type="text"
            value={offerName}
            onChange={(e) => setOfferName(e.target.value)}
            required
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Offer Detail</label>
          <textarea
            value={offerDetail}
            onChange={(e) => setOfferDetail(e.target.value)}
            required
            style={styles.textarea}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Offer Status</label>
          <select
            value={offerStatus}
            onChange={(e) => setOfferStatus(e.target.value)}
            style={styles.input}
          >
            <option value="Blocked">Blocked</option>
            <option value="Unblocked">Unblocked</option>
          </select>
        </div>
        <div style={styles.buttonGroup}>
          <button type="button" onClick={() => {setOfferName(""); setOfferDetail(""); setOfferStatus("Blocked");}} style={styles.cancelButton}>Cancel</button>
          <button type="submit" style={styles.createButton}>Create</button>
        </div>
      </form>

      <div style={styles.tableContainer}>
        <h3 style={styles.offerListHeader}>Offer List</h3>
        <table style={styles.table}>
          <thead>
            <tr style={styles.tableHeaderRow}>
              <th style={styles.tableHeader}>Sr No.</th>
              <th style={styles.tableHeader}>Offer Name</th>
              <th style={styles.tableHeader}>Offer Detail</th>
              <th style={styles.tableHeader}>Status</th>
              <th style={styles.tableHeader}>Action</th>
              <th style={styles.tableHeader}>Update</th>
            </tr>
          </thead>
          <tbody>
            {offerList.map((offer) => (
              <tr key={offer.srNo} style={styles.tableRow}>
                <td style={styles.tableCell}>{offer.srNo}</td>
                <td style={styles.tableCell}>{offer.offerName}</td>
                <td style={styles.tableCell}>{offer.offerDetail}</td>
                <td style={styles.tableCell}>{offer.status}</td>
                <td style={styles.tableCell}>
                  <button
                    onClick={() => handleStatusToggle(offer.srNo)}
                    style={offer.status === "Blocked" ? styles.unblockButton : styles.blockButton}
                  >
                    {offer.status === "Blocked" ? "Unblock" : "Block"}
                  </button>
                </td>
                <td style={styles.tableCell}>
                  <button
                    onClick={() => handleEditOffer(offer.srNo)}
                    style={styles.editButton}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "1200px",
    margin: "20px auto",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
  },
  header: {
    textAlign: "center",
    fontSize: "24px",
    color: "#2c3e50",
    marginBottom: "20px",
  },
  form: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "15px",
    marginBottom: "30px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#34495e",
  },
  input: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px",
    color: "#34495e",
  },
  textarea: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px",
    color: "#34495e",
    minHeight: "100px",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "space-between",
  },
  cancelButton: {
    padding: "10px 20px",
    backgroundColor: "#e74c3c",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
  },
  createButton: {
    padding: "10px 20px",
    backgroundColor: "#3498db",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "background-color 0.3s ease",
  },
  tableContainer: {
    overflowX: "auto",
    marginTop: "20px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },
  tableHeaderRow: {
    backgroundColor: "#2c3e50",
    color: "#fff",
  },
  tableHeader: {
    padding: "12px",
    textAlign: "left",
    fontSize: "14px",
  },
  tableRow: {
    backgroundColor: "#f9f9f9",
    transition: "background-color 0.3s ease",
  },
  tableCell: {
    padding: "12px",
    fontSize: "14px",
  },
  unblockButton: {
    padding: "8px 15px",
    backgroundColor: "#27ae60",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  blockButton: {
    padding: "8px 15px",
    backgroundColor: "#e74c3c",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  editButton: {
    padding: "8px 15px",
    backgroundColor: "#f39c12",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default AddOffer;
